import React, { Component } from "react";
import { Translate } from "react-redux-i18n";

import ChargerInfoModal from "../modals/ChargerInfoModal";

import "../../../styles/components/map/chargerInfo/OperatorInfo.scss";
import info from "../../../styles/images/info.svg";

class OperatorInfo extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      more: false,

      modals: {
        info: false,
      },
    };
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  setModal(modal, bool) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState({
      modals: newModals,
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    const {
      network,
      operator,
      hwId,
      manufacturer,
      model,
      operatorContact,
      operatorEmail,
    } = this.props.charger.properties;

    return (
      <>
        <div id="operatorInfo">
          <div className="item-container">
            <div className="item">
              <p>
                <Translate value="operatorInfo_network" />
              </p>
              <b>{network ? network : "-"}</b>
            </div>
            <div className="item">
              <p>
                <Translate value="operatorInfo_operator" />
                <button type="button" className="clear" onClick={() => this.setModal("info", true)}>
                  <img src={info} alt="" />
                </button>
              </p>
              <b>{operator ? operator : "-"}</b>
            </div>
            {this.state.more && (
              <>
                <div className="item">
                  <p>
                    <Translate value="operatorInfo_chargerIdentifier" />
                  </p>
                  <b>{hwId ? hwId : "-"}</b>
                </div>
                <div className="item">
                  <p>
                    <Translate value="operatorInfo_chargerManufacturer" />
                  </p>
                  <b>{manufacturer ? manufacturer : "-"}</b>
                </div>
                <div className="item">
                  <p>
                    <Translate value="operatorInfo_chargerModel" />
                  </p>
                  <b>{model ? model : "-"}</b>
                </div>
              </>
            )}
          </div>
          <button
            type="button"
            className="more clear"
            onClick={() =>
              this.safeSetState(prevState => ({
                more: !prevState.more,
              }))
            }
          >
            {!this.state.more ? (
              <p>
                + <Translate value="operatorInfo_more" />
              </p>
            ) : (
              <p>
                - <Translate value="operatorInfo_less" />
              </p>
            )}
          </button>
          <hr />
        </div>

        <ChargerInfoModal
          show={this.state.modals.info}
          onHide={() => this.setModal("info", false)}
          mode="operatorInfo"
          info={{operatorContact, operatorEmail}}
        />
      </>
    );
  }
}

export default OperatorInfo;
